import { Constants } from "../constants/constants";

const ORIGIN = Constants.API_BASE_URL.replace(/\/+$/, "").replace(/\/api$/i, "");

export const resolveImageUrl = (url?: string | null): string | undefined => {
  if (!url) return undefined;
  if (/^https?:\/\//i.test(url)) return url;
  return `${ORIGIN}/${url.replace(/^\/+/, "")}`;
};

export const isImageUrl = (value?: string | null): boolean => {
  if (!value) return false;
  if (/^data:image\//i.test(value)) return true;
  const path = value.split("?")[0].split("#")[0];
  if (/\.(png|jpe?g|gif|svg|webp|ico|bmp|avif)$/i.test(path)) return true;
  if (/^https?:\/\//i.test(value)) return true;
  return false;
};